import { EntityPropList } from '@abp/ng.components/extensible';

/**
 * Lets every data column of an ABP extensible table auto-resize instead of using its fixed default width.
 *
 * ABP 10.3's `abp-extensible-table` overwrites its default actions column width with `undefined` when the
 * host page doesn't pass `actionsColumnWidth`, which turns the actions column into an auto-resizing one.
 * On pages whose default props all carry a `columnWidth` (OpenIddict Applications/Scopes, Languages) that
 * column is then the only flexible one, so it swallows the free width and pushes the data columns to the
 * right edge. Clearing the fixed widths spreads the width across all columns again.
 */
export function autoSizeEntityPropColumns<T>(propList: EntityPropList<T>): void {
  propList.forEach(node => Object.assign(node.value, { columnWidth: undefined }));
}
